import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contenido'
})
export class ContenidoPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    if(value.length >=50)
    {
      value = value.substring(0,100);
      return value+"...";
    }
    else
    {
      return value;
    }
    
  }

}
